import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import GlobalDialog from '../../mui/Dialogue/GlobalDialog';
import { AddButton, CancelButton, SubmitButton, UpdateButton } from '../../mui/Buttons/Buttons';
import { useFormik, FormikProvider, Form } from 'formik';
import * as Yup from 'yup';
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  ImageList,
  ImageListItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { createCourse, getAllCourses, updateCourse } from '../../../redux/features/courseSlice';
import GlobalSelectField from '../../mui/GlobalSelectField';
import { compressImage } from '../../../utils/constants/ImageCompress';
import { savePaginationData } from '../../../redux/features/globalDatagridSlice';
import DynamicFormikForm from './TestPopup';
import { SKILLX_DEPARTMENT_ID } from '../../../utils/constants/GlobalStaticData';

const courseType = [
  { id: 0, value: 'Individual' },
  { id: 1, value: 'Group' },
];
const courseEnrollmentTypes = [
  { id: 'normal', value: 'Normal' },
  { id: 'simple', value: 'Simple' },
];
const data = [
  { id: 1, name: 'English' },
  { id: 2, name: 'Malayalam' },
];
const courseTypesData = [
  { courseTypeId: 1, courseType: 'Options' },
  { courseTypeId: 2, courseType: 'Percentage' },
];

const AddOrUpdateCourse = ({ row }) => {
  const profile = JSON.parse(localStorage.getItem('cred'))?.profile;
  const [compressDelay, setCompressDelay] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading, projects } = useSelector((store) => store.course);
  const fileInputRef = useRef(null);
  const [imageGallery, setImageGallery] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [imageChoosen, setImageChoosen] = useState(false);
  const [paymentCompare, setPaymentCompare] = useState(false);
  const { course } = useSelector((state) => state.course);
  const { subjects } = useSelector((state) => state.cro);
  const { categories } = useSelector((state) => state.cart);

  const images = require.context('../../../../src/img/courses/', false, /\.(png|jpe?g|svg|webp)$/);
  const imagePaths = images.keys();
  // useEffect(() => {
  //   if (profile.departmentId === 34) {
  //     courseTypesData.push({ courseTypeId: 3, courseType: 'Normal' });
  //   }
  // }, [profile]);
  useEffect(() => {
    const imageData = imagePaths.map((imagePath, index) => ({
      img: images(imagePath), //IT RETURN IMG SRC
      title: `Course Image ${index + 1}`,
    }));
    setItemData(imageData);
  }, [imageGallery]);

  const initialValues = {
    isUpdate: row ? true : false,
    projectId: row?.projectId || '',
    courseName: row?.courseName || '',
    courseOutcomes: row?.courseOutcomes || '',
    batchAvailability: row ? row.batchAvailability : profile?.departmentId === SKILLX_DEPARTMENT_ID ? 1 : '',
    pricePerSession: row?.price_per_session || '',
    categoryId: row?.categoryId || '',
    file: '',
    package: row?.package || false,
    courseTypeId: row?.courseTypeId || '',
    courseEnrollmentType: row?.courseEnrollmentType || '',
    courseLevelStatus: row?.courseLevelStatus || false,
    options: row?.options || [
      {
        NoOfSessions: '',
        amount: '',
        amountAed: '',
        options: [{ terms: [{ InrTerm: '', AedTerm: '' }], discount: '', active: true }],
      },
    ],
    subjects: row?.subjects || [],
  };

  const schema = Yup.object({
    projectId: Yup.number()
      .transform((value, originalValue) => Number(originalValue))
      .required('Project Required'),
    batchAvailability: Yup.number().when([], {
      is: () => profile?.departmentId === SKILLX_DEPARTMENT_ID,
      then: Yup.number(),
      otherwise: Yup.number().required('Course Type Required'),
    }),

    categoryId: Yup.number().when([], {
      is: () => profile?.departmentId === SKILLX_DEPARTMENT_ID,
      then: (schema) => schema.required('Category is required'),
      otherwise: (schema) => schema.notRequired(),
    }),

    courseName: Yup.string().required('Course Name Required'),
    courseTypeId: Yup.number().required('Course Type Required'),
    courseEnrollmentType: Yup.string().required('Enrollment Type Required'),
    file: Yup.mixed().when('isUpdate', {
      is: false,
      then: Yup.mixed().required('Course Image is required'),
      otherwise: Yup.mixed().nullable(),
    }),
    // -----------------------------------------------
    options: Yup.array().when('courseTypeId', {
      is: (value) => Number(value) !== 2,
      then: Yup.array().of(
        Yup.object().shape({
          NoOfSessions: Yup.string().required('Required'),
          amount: Yup.string().required('Required'),
          amountAed: Yup.string().required('Required'),
          options: Yup.array()
            .of(
              Yup.object().shape({
                terms: Yup.array().of(
                  Yup.object().shape({
                    InrTerm: Yup.string().required('INR Term is required'),
                    AedTerm: Yup.string().required('AED Term is required'),
                  })
                ),
                discount: Yup.string().required('Required'),
              })
            )
            .min(1, 'At least one nested option is required'),
        })
      ),
      otherwise: Yup.array().of(
        Yup.object().shape({
          NoOfSessions: Yup.string().notRequired(),
        })
      ),
    }),

    // -----------------------------------------
    package: Yup.boolean(),
    subjects: Yup.array()
      .of(Yup.number().required('Subject ID is required'))
      .when('package', {
        is: true,
        then: (schema) => schema.min(1, 'At least one subject is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: schema,
    onSubmit: (values) => {
      if (row) {
        const updatedValues = {
          ...values,
          options: JSON.stringify(values.options),
          subjects: JSON.stringify(values.subjects),
        };
        dispatch(updateCourse({ ...updatedValues, id: row.id })).then((res) => {
          if (res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
          } else if (res.payload.status === 'success') {
            handleCancel();
            dispatch(savePaginationData({ ...paginationData, openAnchor: false }));
            dispatch(getAllCourses(paginationData));
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
          }
        });
      } else {
        const updatedValues = {
          ...values,
          options: JSON.stringify(values.options),
          subjects: JSON.stringify(values.subjects),
        };
        dispatch(createCourse(updatedValues)).then((res) => {
          if (res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
          } else if (res.payload.status === 'success') {
            handleCancel();
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
            dispatch(getAllCourses(paginationData));
          }
        });
      }
    },
  });

  const handleCancel = () => {
    setOpen(false);
    setImageChoosen(false);
    formik.resetForm();
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleFileChange = async (e, imagePath = null) => {
    let file;
    if (imagePath) {
      const response = await fetch(imagePath);
      const blob = await response.blob();
      file = new File([blob], 'course-image.png', { type: blob.type });
      setImageChoosen(true);
    } else {
      file = e.currentTarget.files[0];
    }
    setCompressDelay(true);
    const compressed = await compressImage(file, 0.002);
    setCompressDelay(false);
    formik.setFieldValue('file', compressed);
  };

  const handleProjectChange = useCallback(
    (e, option) => {
      if (option) {
        formik.setFieldValue('projectId', option.id);
      } else {
        formik.setFieldValue('projectId', '');
      }
    },
    [formik]
  );

  const handleCourseTypeChange = useCallback(
    (e, option) => {
      if (option) {
        formik.setFieldValue('courseTypeId', option.courseTypeId);
      }
    },
    [formik]
  );

  const handleCategorieChange = useCallback(
    (e, option) => {
      if (option) {
        formik.setFieldValue('categoryId', option.course_category_id);
      }
    },
    [formik]
  );

  const handleChange = useCallback(
    (event) => {
      formik.setFieldValue('package', event.target.checked);
    },
    [formik]
  );

  const handleCourseLevelStatus = useCallback((e) => {
    formik.setFieldValue('courseLevelStatus', e.target.checked);
  });

  return (
    <>
      <GlobalDialog
        maxWidth={'xl'}
        fullWidth
        title={row ? 'Update Course' : 'Add Course'}
        open={open}
        setOpen={setOpen}
        closeButton={true}
        closeCondition={handleCancel}
        popupButton={
          <>
            {row ? (
              <UpdateButton size="small" action={() => setOpen(true)}>
                Update
              </UpdateButton>
            ) : (
              <AddButton
                size="large"
                action={() => {
                  setOpen(true);
                }}
              >
                Add Course
              </AddButton>
            )}
          </>
        }
        content={
          <>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Stack gap={1}>
                  <Box>
                    <Autocomplete
                      disabled={loading}
                      name="projectId"
                      options={projects}
                      getOptionLabel={(option) => option.name || ''}
                      value={projects.find((pro) => pro.id == formik.values.projectId) || null}
                      onChange={handleProjectChange}
                      renderInput={(params) => (
                        <TextField
                          disabled
                          fullWidth
                          autoComplete="off"
                          {...params}
                          label={'Select Project'}
                          error={formik.touched.projectId && Boolean(formik.errors.projectId)}
                          helperText={formik.touched.projectId && formik.errors.projectId}
                        />
                      )}
                    />
                  </Box>
                  {formik.values.projectId ? (
                    <Box>
                      <Autocomplete
                        disabled={loading}
                        name="courseTypeId"
                        options={courseTypesData}
                        getOptionLabel={(option) => option.courseType || ''}
                        value={courseTypesData.find((pro) => pro.courseTypeId == formik.values.courseTypeId) || null}
                        onChange={handleCourseTypeChange}
                        renderInput={(params) => (
                          <TextField
                            disabled
                            fullWidth
                            autoComplete="off"
                            {...params}
                            label="Course Type"
                            error={formik.touched.courseTypeId && Boolean(formik.errors.courseTypeId)}
                            helperText={formik.touched.courseTypeId && formik.errors.courseTypeId}
                          />
                        )}
                      />
                    </Box>
                  ) : null}

                  {profile?.departmentId === SKILLX_DEPARTMENT_ID ? (
                    <Box>
                      <Autocomplete
                        disabled={loading}
                        name="categoryId"
                        options={categories}
                        getOptionLabel={(option) => option.course_category_name || ''}
                        value={categories.find((pro) => pro.course_category_id == formik.values.categoryId) || null}
                        onChange={handleCategorieChange}
                        renderInput={(params) => (
                          <TextField
                            disabled
                            fullWidth
                            autoComplete="off"
                            {...params}
                            label="Category"
                            error={formik.touched.categoryId && Boolean(formik.errors.categoryId)}
                            helperText={formik.touched.categoryId && formik.errors.categoryId}
                          />
                        )}
                      />
                    </Box>
                  ) : null}

                  <TextField
                    name="courseName"
                    fullWidth
                    type="text"
                    value={formik.values.courseName}
                    label="Course Name"
                    error={formik.touched.courseName && Boolean(formik.errors.courseName)}
                    helperText={formik.touched.courseName && formik.errors.courseName}
                    onChange={(e) => {
                      formik.setFieldValue('courseName', e.target.value.toUpperCase());
                    }}
                    autoComplete="off"
                  />
                  <GlobalSelectField
                    options={{
                      formik: formik,
                      label: 'Enrollment Type',
                      name: 'courseEnrollmentType',
                      data: courseEnrollmentTypes,
                      keys: {
                        id: 'id',
                        value: 'value',
                      },
                      sx: {
                        width: '100%',
                      },
                    }}
                  />
                  {/* ---------------------------------------------------------- */}

                  {profile?.departmentId == SKILLX_DEPARTMENT_ID ? null : (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formik.values.courseLevelStatus}
                            onChange={handleCourseLevelStatus}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        }
                        label="Level"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formik.values.package}
                            onChange={handleChange}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        }
                        label="Package"
                      />
                    </>
                  )}

                  {formik.values.package ? (
                    <Autocomplete
                      multiple
                      options={subjects}
                      getOptionLabel={(option) => option.subjectName}
                      value={subjects.filter((s) => formik.values.subjects?.includes(s.subjectId)) || []}
                      onChange={(event, newValue) => {
                        const subjectIds = newValue.map((subject) => subject.subjectId);
                        formik.setFieldValue('subjects', subjectIds);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Subjects"
                          variant="outlined"
                          error={formik.touched.subjects && Boolean(formik.errors.subjects)}
                          helperText={formik.touched.subjects && formik.errors.subjects}
                        />
                      )}
                    />
                  ) : null}
                  {/* -------------------fee optiions---------------------------- */}
                  {formik.values.courseTypeId == 1 ? (
                    <DynamicFormikForm setPaymentCompare={setPaymentCompare} formik={formik} />
                  ) : null}

                  {/* -------------------fee optiions---------------------------- */}
                  <TextField
                    name="courseOutcomes"
                    fullWidth
                    type="text"
                    value={formik.values.courseOutcomes}
                    label="Description"
                    error={formik.touched.courseOutcomes && Boolean(formik.errors.courseOutcomes)}
                    helperText={formik.touched.courseOutcomes && formik.errors.courseOutcomes}
                    onChange={formik.handleChange}
                    autoComplete="off"
                  />
                  {profile?.departmentId === SKILLX_DEPARTMENT_ID ? null : (
                    <GlobalSelectField
                      options={{
                        formik: formik,
                        label: 'Course Type',
                        name: 'batchAvailability',
                        data: courseType,
                        keys: {
                          id: 'id',
                          value: 'value',
                        },
                        sx: {
                          width: '100%',
                        },
                      }}
                    />
                  )}

                  <Box>
                    <Typography sx={{ pl: 1.7, color: '#697077' }}>
                      {row ? 'Replace Course Image' : 'Course Image'}
                    </Typography>
                    {!imageChoosen && (
                      <TextField
                        name="file"
                        disabled={compressDelay}
                        onChange={handleFileChange}
                        inputRef={fileInputRef}
                        type="file"
                        error={formik.touched.file && Boolean(formik.errors.file)}
                        helperText={formik.touched.file && formik.errors.file}
                      />
                    )}
                  </Box>
                  <Box>
                    {imageGallery && (
                      <Box>
                        <ImageList sx={{ width: '100%', height: 'auto' }} cols={5} rowHeight={164}>
                          {itemData.map((item) => (
                            <ImageListItem key={item.img}>
                              <img
                                className="image-item"
                                src={item.img}
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  objectFit: 'contain',
                                }}
                                alt={item.title}
                                onClick={() => {
                                  handleFileChange(null, item.img);
                                  setImageGallery(false);
                                  fileInputRef.current.value = 'image choosen';
                                }}
                              />
                            </ImageListItem>
                          ))}
                        </ImageList>
                      </Box>
                    )}
                  </Box>
                </Stack>

                <Box sx={{ mt: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Stack direction={'row'} spacing={1}>
                      <CancelButton action={handleCancel}>Cancel</CancelButton>
                      {row ? (
                        <UpdateButton disabled={loading || compressDelay} type="submit">
                          {loading ? 'Updating...' : 'Update'}
                        </UpdateButton>
                      ) : (
                        <SubmitButton disabled={loading || compressDelay || paymentCompare} type="submit">
                          {loading ? ' Please Wait' : 'Save'}
                        </SubmitButton>
                      )}
                    </Stack>
                  </Box>
                </Box>
              </Form>
            </FormikProvider>
          </>
        }
      />
    </>
  );
};

export default AddOrUpdateCourse;
